import React from "react";

// ATDW Pixel Tracking Utility
// Based on ATDW documentation: https://developer.atdw.com.au/ATDWO-tracking-beacon.html

/**
 * Creates an ATDW tracking pixel element
 * @param {string} pixelUrl - The pixel URL from ATDW API response
 * @returns {HTMLElement|null} - The img element or null if no URL provided
 */
export const createAtdwPixel = (pixelUrl) => {
  if (!pixelUrl) {
    return null;
  }

  const img = document.createElement('img');
  img.src = pixelUrl;
  img.width = 1;
  img.height = 1;
  img.border = 0;
  img.alt = '';
  img.style.position = 'absolute';
  img.style.left = '-9999px';
  
  return img;
};

/**
 * Adds ATDW pixel tracking to the current page
 * @param {string} pixelUrl - The pixel URL from ATDW API response
 */
export const addAtdwPixelTracking = (pixelUrl) => {
  if (!pixelUrl) {
    console.warn('ATDW pixel URL not provided');
    return;
  }

  const pixel = createAtdwPixel(pixelUrl);
  if (pixel) {
    document.body.appendChild(pixel);
    console.log('ATDW pixel tracking added:', pixelUrl);
  }
};

/**
 * Removes ATDW pixel tracking from the page
 * @param {string} pixelUrl - The pixel URL to remove
 */
export const removeAtdwPixelTracking = (pixelUrl) => {
  if (!pixelUrl) return;
  
  const existingPixel = document.querySelector(`img[src="${pixelUrl}"]`);
  if (existingPixel) {
    existingPixel.remove();
    console.log('ATDW pixel tracking removed:', pixelUrl);
  }
};

/**
 * React component for ATDW pixel tracking
 * @param {Object} props
 * @param {string} props.pixelUrl - The pixel URL from ATDW API response
 * @returns {JSX.Element|null} - The pixel img element or null
 */
export const AtdwPixel = ({ pixelUrl }) => {
  if (!pixelUrl) {
    return null;
  }

  return (
    <img 
      src={pixelUrl} 
      width="1" 
      height="1" 
      border="0" 
      alt="" 
      style={{ position: 'absolute', left: '-9999px' }}
    />
  );
}; 